export default "__VITE_ASSET__DEhKbkFc__"